import { render, staticRenderFns } from "./CustomProductList.vue?vue&type=template&id=726bd6ca&scoped=true&"
import script from "./CustomProductList.vue?vue&type=script&lang=js&"
export * from "./CustomProductList.vue?vue&type=script&lang=js&"
import style0 from "./CustomProductList.vue?vue&type=style&index=0&id=726bd6ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726bd6ca",
  null
  
)

export default component.exports